
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import Chatbot from "./components/feature/Chatbot";
import WhatsAppButton from "./components/feature/WhatsAppButton";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <Chatbot />
      <WhatsAppButton />
    </BrowserRouter>
  );
}

export default App;
